require('./hero-checkbox.css');
import { CheckboxWidget } from './hero-checkbox.js';
export { CheckboxWidget };
